export default __webpack_public_path__ + "static/media/x33mall-banner.23b08b0c.webp";